/* global Lang */

import React from 'react';
import Card, { CardBody, CardTitle } from '../Card';
import ObjectTranslation from '../ObjectTranslation';
import ProgressBar from '../ProgressBar';

const TYPE_PARCHMENT = 'parchment';
const TYPE_PARCHMENT_PIECE = 'parchment_piece';

export default ({ inventory, levels, totals }) => (
  <>
    <h3 className="bg-body">
      {Lang.get('messages.dashboard.inventory.myParchments')}
      {` (${inventory.filter(({ type }) => type === TYPE_PARCHMENT).length}/${totals.parchments})`}
    </h3>
    <div className="row">
      {levels.map((level) => {
        if (level.slug === 'troonzaal') {
          // no scroll piece in this level
          return null;
        }
        let collected = 0;
        let parchment = null;
        const pieces = 4;
        // reverse loop, because the completed parchment will always be last
        // and if you find that one, there is no longer need to check for pieces
        for (let i = inventory.length - 1; i >= 0; i -= 1) {
          const item = inventory[i];
          const {
            type,
            data: { level: itemLevel },
          } = item;
          if (itemLevel.id === level.id) {
            if (type === TYPE_PARCHMENT) {
              parchment = item;
              collected = pieces;
              break;
            } else if (type === TYPE_PARCHMENT_PIECE) {
              collected += 1;
            }
          }
        }
        return (
          (collected || parchment) && (
            <div key={level.slug} className="col-6 col-md-4 col-lg-3 mb-4">
              <Card className="h-100">
                <CardBody>
                  <CardTitle>{level.title}</CardTitle>
                  <div className="d-flex flex-row align-items-center">
                    <img
                      src={`/assets/game/sprites/scrolls/${
                        parchment ? 'scroll_full' : 'part_01'
                      }.png`}
                      width="50"
                      alt={level.title}
                      className="mr-2 align-self-start"
                    />
                    {collected < pieces ? (
                      <ProgressBar
                        value={collected}
                        max={pieces}
                        label={`${collected}/${pieces}`}
                      />
                    ) : (
                      <ObjectTranslation index="description" object={parchment.data.translations} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
          )
        );
      })}
    </div>
  </>
);
